/* eslint-disable */
import { useState, useEffect, createContext } from 'react'

export const PageContext = createContext()

const PageContextProvider = (props) => {
  const lang = localStorage.getItem('language')
  const savedTheme = localStorage.getItem('bpg_theme')

  const [language, setLanguage] = useState(lang ? lang : 'AZ')
  const [verification, setVerification] = useState(null)
  const [theme, setTheme] = useState(savedTheme ? savedTheme : 'light')

  useEffect(() => {
    const root = document.documentElement
    root.setAttribute('data-theme', theme)
    if (theme === 'dark') {
      root.classList.add('dark')
      if (document.body) document.body.classList.add('dark')
    } else {
      root.classList.remove('dark')
      if (document.body) document.body.classList.remove('dark')
    }
    localStorage.setItem('bpg_theme', theme)
  }, [theme])

  const ChangeLanguage = (lang) => {
    localStorage.setItem('language', lang)
    setLanguage(lang)
  }

  const ChangeVerification = (code) => {
    setVerification(code)
  }

  const toggleTheme = (override) => {
    setTheme((prev) => {
      const next = typeof override === 'string' ? override : prev === 'dark' ? 'light' : 'dark'
      return next
    })
  }

  return (
    <PageContext.Provider
      value={{
        language,
        ChangeLanguage,
        verification,
        ChangeVerification,
        theme,
        toggleTheme,
      }}
    >
      {props.children}
    </PageContext.Provider>
  )
}

export default PageContextProvider
